import {
	initDataSourceLogs,
	initDownloadButton,
	initRefreshButton,
	initSubLevelTabs
} from './data_source.js';

function parseHash(hash) {
	let cleaned = (hash || '').replace(/^#/, '');
	if (!cleaned) return ['', ''];
	let parts = cleaned.split('/');
	return [parts[0] || '', parts[1] || ''];
}

function showTopLevelTab(topId) {
	$('.tabs_wrap .single_tab').removeClass('active');
	$('.tabs_wrap_content_wrap .tabs_wrap_content').removeClass('active');

	let $btn = $(`.single_tab[data-tab="#${topId}"]`);
	if ($btn.length) {
		$btn.addClass('active');
		$(`#${topId}`).addClass('active');
	} else {
		// Fallback
		let $first = $('.tabs_wrap .single_tab').first();
		$first.addClass('active');
		$($first.data('tab')).addClass('active');
	}
}

function initTopLevelTabs() {
	$('.tabs_wrap').on('click', '.single_tab', function(e) {
		e.preventDefault();
		const $clicked  = $(this);
		const targetTab = $clicked.data('tab');

		// Deactivate old
		$('.tabs_wrap .single_tab').removeClass('active');
		$('.tabs_wrap_content_wrap .tabs_wrap_content').removeClass('active');

		// Activate new
		$clicked.addClass('active');
		$(targetTab).addClass('active');

		// Update hash
		let [oldTop, oldSub] = parseHash(location.hash);
		let newTop = targetTab.replace('#','');
		let newHash = oldSub ? `${newTop}/${oldSub}` : newTop;
		location.hash = newHash;
	});
}

$(document).ready(function() {
	// 1) Initialize top-level tabs
	initTopLevelTabs();

	// 2) Parse hash for top-level
	let [top, sub] = parseHash(location.hash);
	if (top) {
		showTopLevelTab(top);
	} else {
		// fallback => first top-level
		$('.tabs_wrap .single_tab').first().trigger('click');
		top = $('.tabs_wrap .single_tab').first().data('tab').replace('#','');
	}

	// 3) Initialize sub-level tabs (important!)
	//    This sets up the logic that checks .single_tab.active
	//    and finds the correct sub-level tab.
	initSubLevelTabs();

	// 4) If there's a sub portion of the hash, show that sub-level tab
	if (sub) {
		let $subLink = $(`.nav-link[data-bs-toggle="tab"][href="#${sub}"]`);
		if ($subLink.length) {
			let tab = new bootstrap.Tab($subLink[0]);
			tab.show();
		} else {
			// fallback => first sub in that container
			let $firstSub = $(`#${top}`).find('a.nav-link[data-bs-toggle="tab"]').first();
			if ($firstSub.length) {
				let tab = new bootstrap.Tab($firstSub[0]);
				tab.show();
			}
		}
	} else {
		// If no sub, show first sub-level
		let $firstSub = $(`#${top}`).find('a.nav-link[data-bs-toggle="tab"]').first();
		if ($firstSub.length) {
			let tab = new bootstrap.Tab($firstSub[0]);
			tab.show();
		}
	}

	// 5) Initialize logs, download, refresh
	initDataSourceLogs();
	initDownloadButton();
	initRefreshButton();
});
